import Slider from '../product-slider/product-slider';
import LazyLoad from '../../../js/lazy-load';

export default new class ProductTab {
  constructor() {
    this.linkTabSelector = 'product-descr__link';
    this.activeLinkTabSelector = 'product-descr__link_active';
    this.contentSelector = 'product-descr__content';
    this.invisibleContentSelector = 'product-descr__content_visually-hidden';
    this.descRental = 'product-descr__rental';
    this.readMore = 'product-descr__read_more';

    this.init();
  }

  init() {
    $(document).on('click', `.${this.linkTabSelector}`, (e) => {
      e.preventDefault();

      const { target } = e;

      if ($(target).hasClass(this.activeLinkTabSelector)) return;

      this.showTab(target);
    });

    $(document).on('click', '.product-descr__read_more', (e) => {
      e.preventDefault();
      const rental = $('.product-descr__rental');
      const readmore = $('.product-descr__read_more');
      if (rental.hasClass('close')) {
        rental.removeClass('close');
        readmore.text('Vedi meno');
      } else {
        rental.addClass('close');
        readmore.text('Vedi di più');
      }
    });

    $(document).on('click', '.target-region', ({ currentTarget }) => {
      const id = $(currentTarget).attr('data-id');
      const product_id = $('#mappa-css').attr('data-product-id');
      $.request('onSearchResellers', {
        data: { id, product_id },
      });
    });

    $(document).on('change', '#map-state', ({ currentTarget }) => {
      const id = $(currentTarget).val();
      const product_id = $('#mappa-css').attr('data-product-id');
      $.request('onSearchResellers', {
        data: { id, product_id },
      });
    });

    $(document).on('click', '#back-to-map-btn', ({ currentTarget }) => {
      const product_id = $('.reseller-list').data('product-id');
      $.request('onReturnToMap', {
        data: { product_id },
        complete() {
          tippy('[data-tippy-content]');
        },
      });
    });
  }

  hideTab() {
    const tabCollection = $(`.${this.linkTabSelector}`);
    const tabContentCollection = $(`.${this.contentSelector}`);

    [...tabCollection].forEach(tab => $(tab).removeClass(this.activeLinkTabSelector));
    [...tabContentCollection].forEach(el => $(el).addClass(this.invisibleContentSelector));
  }

  showTab(target) {
    const id = $(target).attr('href');
    const tabContent = $(id);

    this.hideTab();

    $(target).addClass(this.activeLinkTabSelector);

    tabContent.removeClass(this.invisibleContentSelector);
    if ($(`.${this.descRental}`).outerHeight() > 400) {
      $(`.${this.descRental}`).addClass('close');
      $(`.${this.readMore}`).show().text('Vedi di più');
    } else {
      $(`.${this.readMore}`).hide();
    }
  }
}();
